




















import { Component, Vue } from 'vue-property-decorator'
import { FinanceState } from '../store'

@Component({
  components: {
  }
})
export default class FinanceRoot extends Vue {
  private errorMessage = ''

  public mounted () {

  }

  public created () {
  }

  public activated () {
  }

  public updated () {
  }

  public destroyed () {
  }

  public deactivated () {

  }
}
